import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import styles from "./TitleCardFragment.module.css";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import { useCreateTitle } from "@coworker/apprestructured/src/task-management/services/useCreateTitle";

export type TitleCardFragmentConfigProps = EmptyObject;

type TitleCardFragmentProps = {
  commonProps: CardFragmentCommonProps;
};

function TitleCardFragment({ commonProps }: TitleCardFragmentProps) {
  const { task } = commonProps;

  const title = useCreateTitle(task);

  if (isLoading(task) || isLoading(title)) {
    return <LoadingCardFragment />;
  }

  return (
    <FixaText textStyle="Heading.XS" className={styles["root"]}>
      {title}
    </FixaText>
  );
}

export default TitleCardFragment;
